export const LogoMark = ({ className = "" }) => (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
        <defs>
            <linearGradient id="ftf-gold-header" x1="0" y1="1" x2="1" y2="0">
                <stop offset="0" stopColor="#8A6D2F" />
                <stop offset="0.5" stopColor="#C8A45D" />
                <stop offset="1" stopColor="#E4D2A3" />
            </linearGradient>
        </defs>
        <rect x="1.5" y="1.5" width="61" height="61" rx="13" fill="#172337" />
        <rect x="1.5" y="1.5" width="61" height="61" rx="13" fill="none" stroke="url(#ftf-gold-header)" strokeOpacity="0.5" strokeWidth="1.5" />
        <path d="M21 47V17h13" stroke="url(#ftf-gold-header)" strokeWidth="4.2" fill="none" />
        <path d="M34 17c4.5-2.5 8.5-5 13-8.5" stroke="url(#ftf-gold-header)" strokeWidth="3.4" fill="none" strokeLinecap="round" />
        <path d="M35.5 22.5c4-2 7.5-4.5 11-8" stroke="url(#ftf-gold-header)" strokeWidth="2.4" fill="none" strokeLinecap="round" opacity="0.7" />
        <path d="M21 32h6.5l5-6 6 8 6.5-10.5" stroke="#E4D2A3" strokeWidth="2.8" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="45" cy="23.5" r="2.1" fill="#E4D2A3" />
    </svg>
);

export const Wordmark = ({ withTagline = false }) => (
    <span className="leading-none block">
        <span className="font-display font-semibold text-base sm:text-lg text-white tracking-[0.06em] block">FREEDOM</span>
        <span className="text-[9px] tracking-[0.4em] text-[#C8A45D] uppercase block mt-1">Tax&nbsp;Filer</span>
        {withTagline && (
            <span className="text-[8px] tracking-[0.16em] text-white/50 uppercase block mt-1.5">
                Your Taxes. Our Commitment. Your Freedom.
            </span>
        )}
    </span>
);
